const MENU_SALE_ID = "2"
const MENU_PLUS_ID = "8"

export {
    MENU_SALE_ID,
    MENU_PLUS_ID
}